module.exports = __webpack_public_path__ + "static/media/COS_MTD_YPSOMED.313f9946.png";